import { render, staticRenderFns } from "./ServiceResponsibleBonuseEdit.vue?vue&type=template&id=3616d567&scoped=true&"
import script from "./ServiceResponsibleBonuseEdit.vue?vue&type=script&lang=js&"
export * from "./ServiceResponsibleBonuseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3616d567",
  null
  
)

export default component.exports